export default __webpack_public_path__ + "static/media/iconpom.d3461151.png";